import { SITE } from "@/lib/site";

/**
 * Clean icon-only logo mark (oval emblem with tree, water, hills, dot
 * motifs) — uses the standalone transparent icon asset, no clipping or
 * blend modes required.
 */
export default function LogoMark({ size = "w-10 h-10", testId, blend }) {
    return (
        <span
            data-testid={testId}
            className={`relative inline-block ${size}`}
            aria-hidden
        >
            <img
                src={SITE.icon}
                alt=""
                className="w-full h-full object-contain pointer-events-none select-none"
                style={blend ? { mixBlendMode: "multiply" } : undefined}
            />
        </span>
    );
}
